var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.action)?_c('i',_vm._b({staticClass:"iconfont",class:_vm.item.icon,on:{"click":function($event){return _vm.onclilck(_vm.item.clickEvent)}}},'i',[_vm.item],false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }